import React, { useState, useEffect } from "react";

const FillInTheBlanksDraggableReadingAndWriting = ({ sentence, options, onOptionChange, isSubmitted }) => {
  const parts = sentence.split(/(__add_blank__|<span[^>]*>.*?<\/span>)/);
  const placeholderIndices = parts
    .map((part, index) => (part.startsWith("<span") ? index : null))
    .filter((index) => index !== null);
  const initialReplacedOptions = Array(placeholderIndices.length).fill("");
  const [replacedOptions, setReplacedOptions] = useState(initialReplacedOptions);

  const handleDropdownChange = (event, index) => {
    const option = event.target.value;
    replacePlaceholder(index, option);
  };

  const replacePlaceholder = (index, option) => {
    const newReplacedOptions = [...replacedOptions];
    newReplacedOptions[index] = option;
    setReplacedOptions(newReplacedOptions);
    onOptionChange(newReplacedOptions); // Pass updated options to parent
  };

  useEffect(() => {
    setReplacedOptions(initialReplacedOptions);
  }, [sentence]);

  useEffect(() => {
    if (!isSubmitted) {
      setReplacedOptions(initialReplacedOptions);
    }
  }, [isSubmitted]);

  const getCorrectAnswer = (index) => {
    const spanPart = parts[placeholderIndices[index]];
    const correctAnswer = spanPart.match(/<span[^>]*>(.*?)<\/span>/)[1];
    return correctAnswer.trim();
  };

  const isCorrectAnswer = (placeholderIndex) => {
    const correctAnswer = getCorrectAnswer(placeholderIndex);
    return replacedOptions[placeholderIndex] === correctAnswer;
  };

  const isIncorrectOption = (placeholderIndex) => {
    const selectedOption = replacedOptions[placeholderIndex];
    return selectedOption === "" || !isCorrectAnswer(placeholderIndex);
  };

  return (
    <div>
      <p className="my-4 px-6 text-justify">
        {parts.map((part, index) => {
          if (part.startsWith("<span") && part.endsWith("</span>")) {
            const placeholderIndex = placeholderIndices.indexOf(index);

            return (
              <select
                key={index}
                onChange={(event) => handleDropdownChange(event, placeholderIndex)}
                value={replacedOptions[placeholderIndex]}
                className={`inline-block px-8 py-2 border rounded-sm m-1 cursor-pointer ${
                  isSubmitted
                    ? isCorrectAnswer(placeholderIndex)
                      ? "bg-green-300"
                      : isIncorrectOption(placeholderIndex)
                      ? "bg-red-300"
                      : ""
                    : ""
                }`}
                disabled={isSubmitted}
              >
                <option value="">Select...</option>
                {options[placeholderIndex].split(", ").map((option, optionIndex) => (
                  <option key={optionIndex} value={option.trim()}>
                    {option.trim()}
                  </option>
                ))}
              </select>
            );
          } else if (!part.includes("__add_blank__")) {
            return <span key={index}>{part}</span>;
          } else {
            return null;
          }
        })}
      </p>
    </div>
  );
};

export default FillInTheBlanksDraggableReadingAndWriting;
